import React from "react";
import { StyleSheet, Text, View } from "react-native";

interface Props {
  name?: string;
}

const GiftedChatName = ({ name }: Props) => (
  <View style={styles.view}>
    <Text style={styles.text}>{`${name}`}</Text>
  </View>
);

const styles = StyleSheet.create({
  view: {
    display: "flex",
    flexDirection: "row",
  },
  text: {
    color: "#343434",
    fontWeight: "bold",
    padding: 2,
    alignSelf: "center",
    marginLeft: 8,
  },
});

export default GiftedChatName;
